// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Nj48","col":"styles_col__1QVEW","actions":"styles_actions__38a50","conflict":"styles_conflict__2UAlz"};